import { render, staticRenderFns } from "./updDeclareCustomsStateDialog.vue?vue&type=template&id=5970de99&"
import script from "./updDeclareCustomsStateDialog.vue?vue&type=script&lang=js&"
export * from "./updDeclareCustomsStateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5970de99')) {
      api.createRecord('5970de99', component.options)
    } else {
      api.reload('5970de99', component.options)
    }
    module.hot.accept("./updDeclareCustomsStateDialog.vue?vue&type=template&id=5970de99&", function () {
      api.rerender('5970de99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/aeCustomsInventory/updDeclareCustomsStateDialog.vue"
export default component.exports